import { Component, ElementRef, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogPanelComponentContent } from '../../models/dialogs/DialogPanelComponentContent';

@Component({
    selector: 'app-santander-guarantee-increase-modal',
    templateUrl: './santander-guarantee-increase-modal.component.html',
    styleUrls: ['./santander-guarantee-increase-modal.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class SantanderGuaranteeIncreaseModalComponent extends DialogPanelComponentContent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public elementRef: ElementRef,
        private dialogReference: MatDialogRef<SantanderGuaranteeIncreaseModalComponent>,
        private router: Router
    ) {
        super(elementRef, true);
    }

    /**
     * Navega para a página de dados bancários em Minha Conta e fecha o modal
     */
    public authorizeConnection(): void {
        this.router.navigate(['/minha-conta/dados-bancarios?origin=bolsa']);
        this.closeDialog(true);
    }

    /**
     * Fecha o modal
     * @param confirm - indica se a ação foi confirmada
     */
    public closeDialog(confirm: boolean): void {
        super.close(this.dialogReference, confirm);
        this.dialogReference = null;
    }
}
